import React from "react";

import { ArrowLeft, Sparkles } from "lucide-react";
import useAvatarStore from "../stores/avatarStore";

const SessionHeader = ({ onBack }) => {
  const { sessionActive, selectedAvatar } = useAvatarStore();

  return (
    <header className="relative w-full h-16 shrink-0 flex items-center justify-between px-6 z-30 bg-white border-b border-gray-200 shadow-sm">
      {/* Left side: Back to catalog / Title */}
      <div className="flex items-center gap-3">
        <div className="group relative flex items-center justify-center">
          <button
            onClick={onBack}
            className="p-2 text-gray-500 hover:text-gray-800 rounded-full bg-gray-50 border border-gray-200 hover:bg-gray-100 hover:border-gray-300 transition-all shadow-sm"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
          {/* Instant Custom Tooltip */}
          <span className="absolute top-full mt-2.5 scale-0 group-hover:scale-100 transition-all duration-150 origin-top bg-gray-900/95 text-white text-[10px] font-bold py-1 px-2.5 rounded-lg shadow-md pointer-events-none whitespace-nowrap z-50">
            Exit Session
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Sparkles className="w-5 h-5 text-secondary animate-pulse" />
          <span className="font-extrabold text-gray-800 tracking-tight text-base font-inter">
            Sales<span className="text-secondary">Coach</span> AI
          </span>
        </div>
      </div>

      {/* Middle: Active mode badge */}
      {sessionActive && (
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-green-50 border border-green-200 shadow-sm">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
          </span>
          <span className="text-[10px] font-bold text-green-700 tracking-wider uppercase font-inter">
            Session Active
          </span>
        </div>
      )}

      {/* Right side: Selected Coach badge */}
      {selectedAvatar && (
        <div className="text-xs font-medium text-gray-600 font-inter bg-gray-50 px-3 py-1.5 border border-gray-200 rounded-full capitalize shadow-sm">
          Coach: <span className="text-gray-900 font-bold">{selectedAvatar}</span>
        </div>
      )}
    </header>
  );
};

export default SessionHeader;
